import { getContactInfo } from "api/helpAPI";
import ContactPresenter from "./ContactPresenter";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import useApiError from "hook/useApiError";
import { CustomError } from "api/interfaces/commonInterface.interface";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";

export default function ContactContainer() {
  const { handleErrorNotify, lang } = useApiError();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { data, isFetching } = useQuery(
    ["contactInfo", selectedAccount.accountId],
    () => getContactInfo(selectedAccount.accountId),
    {
      onError: (error: CustomError) => {
        if (
          error.response?.data.error === 100001 ||
          error.response?.data.error === 3008
        ) {
          handleErrorNotify(error, lang.label.contact.get.fail);
        }
      },
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );

  return <ContactPresenter data={data?.result} isLoading={isFetching} />;
}
